import angular from 'angular';
import moment from 'moment';
import { dynamicSortMultiple } from '@/shared/utils/dynamicSort';
import dataCacheService from '@/shared/services/DataCacheService';

angular.module('cxRelations').directive('cxLinkedRelationsList', function() {
  return {
    restrict: 'E',
    template: require('./linkedRelationsList.html'),
    scope: true,
    bindToController: {
      data: '=data',
      field: '=',
      relId: '@',
    },
    controllerAs: 'vm',
    require: ['^cxRelationFile', 'cxLinkedRelationsList'],
    link: function(scope, el, attrs, controllers) {
      if (!controllers || controllers.length !== 2) return;
      var cxRelFile = controllers[0];
      var controller = controllers[1];
      controller.setRelationFile(cxRelFile);
    },
    controller: [
      '$q',
      '$http',
      '$state',
      'appUrls',
      'dataCache',
      'relBindSvc',
      'flySvc',
      'ModalService',
      'dialogsSvc',
      'resourceFactorySvc',
      '$translate',
      'translateListFilter',
      '$scope',
      function(
        $q,
        $http,
        $state,
        appUrls,
        dataCache,
        relBindSvc,
        flySvc,
        ModalService,
        dialogsSvc,
        resourceFactorySvc,
        $translate,
        translateListFilter,
        $scope,
      ) {
        const vm = this;
        var resource = resourceFactorySvc.get('relationLink');
        var relationFile = null;
        
        vm.$onInit = function() {
          vm.relation = relBindSvc.relations[vm.relId];
          vm.saving = false;
          vm.linksPerType = [];
          vm.hasPortalConnectPlatform = dataCacheService.hasPortalConnectPlatform(
            vm.relation.companyId,
          );
        };
        const mapLink = link => {
          return link;
        };

        vm.setRelationFile = function(relFile) {
          relationFile = relFile;
        };

        vm.update = function(link) {
          if (vm.saving) return $q.when('');
          vm.saving = true;
          return resource.update(link).$promise.then(
            function(result) {
              vm.saving = false;
              flySvc.success('msgLinkSaved');
              if (result) relBindSvc.updateRelation(vm.relId, result.changes, result.billingErrors);

              return true;
            },
            function(error) {
              vm.saving = false;
              flySvc.error(error.data.code, error.data.parameters);
              return '';
            },
          );
        };

        vm.submit = function(relationLink, value, field) {
          if (angular.equals(relationLink[field], value)) return false;

          var model = angular.copy(relationLink);
          model[field] = value;

          if (model.info) {
            model.info.isPortalUser = model.info.isPortalUser;
            delete model.isPortalUser;
          }

          return vm.update(model);
        };

        vm.setAsMain = function(link) {
          if (vm.saving) return;
          vm.data.forEach(function(item) {
            if (item.id !== link.id) item.isMain = false;
          });
          link.isMain = !link.isMain;
          vm.update(link);
        };
        vm.openInteractionsMailModal = function(link) {
          return () =>
            $state.go('interactions', {
              relationId: link.to,
              openMailModal: true,
            });
        };
        vm.remove = function(link) {
          if (vm.saving) return;
          return dialogsSvc.showYesNo('comfirmDeleteTitle', 'msgConfirmDeleteRelationLink').then(
            function(result) {
              vm.saving = true;

              resource.delete({ id: link.id }).$promise.then(
                function(result) {
                  vm.saving = false;
                  flySvc.success('msgLinkRemoved');
                  if (result)
                    relBindSvc.updateRelation(vm.relId, result.changes, result.billingErrors);

                  var index = vm.data.indexOf(link);
                  if (index >= 0) vm.data.splice(index, 1);
                  vm.rebuildLinksPerType();
                  if (relationFile) {
                    relationFile.refreshOpenSections();
                  }
                  return true;
                },
                function(error) {
                  vm.saving = false;
                  flySvc.error(error.data.code, error.data.parameters);
                  return false;
                },
              );
            },
            function() {
              return false;
            },
          );
        };

        vm.addRelationLink = function() {
          ModalService.showModal({
            template: require('../dialogs/addRelationLinkDialog.html'),
            controller: 'AddRelationLinkDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              relationId: vm.relation.id,
              companyId: vm.relation.companyId,
              relationType: vm.relation.type,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (result) {
                vm.data.push(mapLink(result));
                vm.rebuildLinksPerType();
                if (relationFile) {
                  relationFile.refreshOpenSections();
                }
                flySvc.success('msgConfirmChange');
              }
            });
          });
        };

        vm.openRelationLinkDetails = function(link) {
          ModalService.showModal({
            template: require('../dialogs/editRelationLinkDialog.html'),
            controller: 'EditRelationLinkDialogCtrl',
            controllerAs: 'vm',
            locationChangeSuccess: false,
            inputs: {
              parentId: vm.relation.id,
              relationLink: angular.copy(link),
              updateLink: vm.update,
            },
          }).then(function(modal) {
            modal.element.modal();
            modal.element.on('hidden.bs.modal', function(e) {
              modal.element.off(e); //Remove event
              modal.element.remove(); //Remove element
            });
            modal.close.then(function(result) {
              if (!result) return false;
              // Something was changed reloading link
              if (relationFile) {
                relationFile.refreshOpenSections();
              }
              resource.linkInfo({ id: link.id }, function(data) {
                link.info = data;
              });
            });
          });
        };

        vm.rebuildLinksPerType = function() {
          vm.linksPerType = [];

          vm.data.forEach(link => {
            let type = vm.linksPerType.find(
              x =>
                x.type === link.linkType &&
                (link.linkType === 5 || //Group all partners together
                  x.isPrincipal === link.isPrincipal),
            );

            if (link.linkType === 10 || link.linkType >= 100) {
              type = {
                type: link.linkType,
                isPrincipal: link.isPrincipal,
                label: $translate.instant('Other'),
                links: [],
                isOther: true,
              };
              vm.linksPerType.push(type);
              link.label = translateListFilter(
                link.linkType,
                link.isPrincipal ? 'linktypeto' : 'linktypeback',
              );
            }

            if (!type) {
              type = {
                type: link.linkType,
                isPrincipal: link.isPrincipal,
                label: translateListFilter(
                  link.linkType,
                  link.isPrincipal ? 'linktypeto' : 'linktypeback',
                ),
                links: [],
                isOther: false,
              };
              vm.linksPerType.push(type);
            }
            type.links.push(link);

            if (link.info?.endDate) {
              link.expired = moment.utc(link.info.endDate).isBefore(moment.utc(), 'd');
            }
            if (link.linkType === 5 && link.info.partnershipType == 4) {
              link.expired = true;
            }
            const otherLinks = vm.linksPerType.filter(x => x.isOther === true);

            if (otherLinks.length > 1) {
              const links = vm.linksPerType.filter(x => x.isOther === false);
              const singleOtherLink = otherLinks[0];

              otherLinks
                .filter((_, i) => i > 0)
                .forEach(x => x.links.forEach(link => singleOtherLink.links.push(link)));
              vm.linksPerType = [...links, singleOtherLink];
            }
          }, []);
          vm.linksPerType.sort(dynamicSortMultiple('label', 'isPrincipal'));
        };

        $scope.$watch(
          'vm.data',
          function(newValue) {
            if (newValue) {
              vm.data = newValue.map(mapLink);
              vm.rebuildLinksPerType();
            }
          },
          true,
        );
      },
    ],
  };
});
